export const PROJECT_CREATE_FIELD_ORDER = [
  "project_name",
  "contract_name",
  "period_start",
  "period_end",
  "contractor",
  "participants",
  "purpose",
];

export function getFirstEmptyProjectCreateField(form = {}) {
  return PROJECT_CREATE_FIELD_ORDER.find(
    (field) => String(form[field] ?? "").trim() === "",
  );
}

export function focusProjectCreateField(inputRefs = {}, field) {
  const focusTarget = () => {
    const target = inputRefs[field]?.current;
    if (!target || typeof target.focus !== "function") return;

    target.scrollIntoView?.({ behavior: "smooth", block: "center" });
    try {
      target.focus({ preventScroll: true });
    } catch {
      target.focus();
    }
  };

  focusTarget();

  if (typeof window !== "undefined") {
    window.requestAnimationFrame?.(focusTarget);
    window.setTimeout(focusTarget, 0);
  }
}

export function showProjectCreateRequiredAlert({
  showAlert,
  inputRefs,
  emptyField,
}) {
  const focusEmptyField = () => focusProjectCreateField(inputRefs, emptyField);

  showAlert({
    textKey: "api.project.create.validation.requiredFields",
    success: false,
    autoClose: true,
    afterClose: focusEmptyField,
  });
  focusEmptyField();
}
